<template>
    <div style="height: 100%; width: 100%; position: relative">
        <div class="teach-page-wrap">
            <div class="teach-page-header">
                <div class="teach-page-name-wrap">
                    <span class="teach-page-name">{{ data.doctor_name }}</span>
                    <span class="teach-page-dept"
                        >{{ data.department_name }} | {{ data.doctor_position }}</span
                    >
                </div>
                <div class="teach-page-info">
                    <div class="teach-page-icon-wrap">
                        <img class="teach-page-icon" :src="data.doctor_photo" alt="" />
                        <p class="teach-page-hospital">{{ data.hospital_name }}</p>
                    </div>
                    <div class="teach-page-desc-wrap">
                        <div class="teach-page-desc" :style="{ height: desc_height }">
                            <span class="teach-page-desc-tag">简介：</span>
                            {{ data.doctor_intro }}
                        </div>
                        <div
                            v-if="Utils.getStringLength(data.doctor_intro) > 50"
                            class="teach-page-desc-more"
                            @click="showDescMore"
                        >
                            {{ show_desc_more ? '收起' : '展开' }}
                        </div>
                    </div>

                    <div class="teach-page-count">
                        <div class="teach-page-count-item">
                            <span class="count-item-number">{{ data.view_num }}</span>
                            <span class="count-item-text">访问</span>
                        </div>
                        <div class="teach-page-count-item" style="margin-left: 1.5rem">
                            <span class="count-item-number">{{ data.praise_num }}</span>
                            <span class="count-item-text">获赞</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="teach-page-tags">
                <template v-for="(word, index) in diseases_list">
                    <div
                        :key="index"
                        :class="[
                            'word-wrap',
                            current_word.disease_id == word.disease_id ? 'word-active' : ''
                        ]"
                        @click="wordClick(word)"
                    >
                        <span class="word-text">{{ word.disease_name }}</span>
                    </div>
                </template>
            </div>
            <div class="teach-list-wrap">
                <template v-if="list_data.length > 0">
                    <list
                        v-model="loading"
                        :finished="finished"
                        :finished-text="finished_text"
                        @load="onLoad"
                    >
                        <div class="teach-list-item-wrap">
                            <template v-for="(item, index) in list_data">
                                <home-list-item
                                    :data="item"
                                    :key="index"
                                    :index="index"
                                    @item-click="itemClick"
                                >
                                </home-list-item>
                            </template>
                        </div>
                    </list>
                </template>
                <!-- <div id="no_data" v-else>
                    <div class="no_img">
                        <p>暂无教学</p>
                    </div>
                </div> -->
            </div>
        </div>

        <img
            @click="show_poster = true"
            class="teach-page-share-poster"
            src="@/assets/images/doctor/share_poster.gif"
            alt=""
        />
        <div @click="clicklinklog" v-if="isappletlink" class="teach-page-msg">
            <div ref="lavContainer"></div>
        </div>
        <doctor-poster
            :data="data"
            v-if="show_poster"
            @poster-close="posterClose"
            :is_production="false"
        >
        </doctor-poster>
    </div>
</template>

<script>
import { List } from 'vant'

import HomeListItem from '@/components/Home/HomeListItem'
import DoctorPoster from '@/components/Doctor/DoctorPoster'
import ItmeSvg from '@/components/svg/ItmeSvg'
import Request from '@request'
import api from '@api'
import Utils from '@/js/Utils'
import lottie from 'lottie-web'
import lottie_xinxi from '../../assets/svg/xinxi'
export default {
    components: {
        List,
        HomeListItem,
        DoctorPoster,
        ItmeSvg
    },
    props: {},
    data() {
        return {
            show_desc_more: false,
            loading: true,
            finished: false,
            swiperOptions: {
                freeMode: true,
                freeModeMomentumRatio: 0.5,
                slidesPerView: 'auto'
            },
            isappletlink: true,
            appletlink: '',
            pageUrl: '',
            current_word: {},
            list_data: [],
            show_poster: false,
            data: {},
            diseases_list: [],
            page: 1,
            finished_text: '',
            consult_url: '',
            Utils
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        },
        desc_height() {
            return this.show_desc_more ? 'auto' : '1.26rem'
        }
    },
    created() {
        this.getData()
        this.getDiseasesList()
        this.getProductionList(false)
        this.getappletlink()
    },
    mounted() {
        lottie.loadAnimation({
            //初始化
            container: this.$refs.lavContainer, //在哪个dom容器中生效
            renderer: 'svg', //渲染方式svg
            animationData: lottie_xinxi //动画数据，这个必须要有
        })
    },
    methods: {
        getappletlink() {
            Request.post(api.doctor.getappletlink, {
                type: 3,
                id: this.$route.query.doctor_id
            }).then(res => {
                const { data, status } = res
                if (data.length) {
                    this.isappletlink = true
                    this.appletlink = data[0].url || data[0].consult_url
                    this.consult_url = data[0].consult_url
                    this.pageUrl = data[0].pageUrl
                } else {
                    this.isappletlink = false
                }
            })
        },
        clicklinklog() {
            Request.post(api.doctor.clicklinklog, {
                appletlink: this.appletlink
            }).then(res => {
                const { data } = res
                let ua = window.navigator.userAgent.toLowerCase()
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    if (this.consult_url) {
                        window.location.href = this.appletlink
                    } else {
                        let pageUrl = this.pageUrl
                        wx.miniProgram.getEnv(a => {
                            if (a.miniprogram) {
                                wx.miniProgram.navigateTo({ url: '/' + pageUrl })
                            } else {
                                window.location.href = this.appletlink
                            }
                        })
                    }
                } else {
                    console.log('不是微信环境')
                    window.location.href = this.appletlink
                }
            })
        },
        getData() {
            Request.post(api.doctor.getdoctorinfo, {
                doctor_id: this.$route.query.doctor_id
            }).then(res => {
                const { data } = res
                this.data = data
            })
        },
        getDiseasesList() {
            Request.post(api.doctor.diseases, {
                doctor_id: this.$route.query.doctor_id
            }).then(res => {
                const { data } = res
                this.diseases_list = [
                    {
                        disease_id: 0,
                        disease_name: '全部'
                    },
                    ...data
                ]
            })
        },
        getProductionList(load_more) {
            if (load_more) {
                this.page++
            } else {
                this.page = 1
            }
            Request.post(api.doctor.productionlist, {
                doctor_id: this.$route.query.doctor_id,
                type: 2,
                userType: 0,
                page: this.page,
                disease_id: this.current_word.disease_id,
                file_type: 2
            }).then(res => {
                const { data } = res
                document.title = '医生主页'
                if (load_more) {
                    this.list_data = [...this.list_data, ...data.list]
                    if (this.page >= data.last_page) {
                        this.finished = true
                    } else {
                        this.finished = false
                    }
                } else {
                    this.list_data = data.list
                    if (this.page >= data.last_page) {
                        this.finished = true
                    } else {
                        this.finished = false
                    }
                }
                this.loading = false
                if (this.list_data && this.list_data.length > 8) {
                    this.finished_text = '- 我也是有底线的 -'
                }
            })
        },
        posterClose() {
            this.show_poster = false
        },
        onLoad() {
            this.getProductionList(true)
        },
        showDescMore() {
            this.show_desc_more = !this.show_desc_more
        },
        wordClick(word) {
            this.current_word = word
            this.getProductionList(false)
        },
        itemClick(item) {
            const { production_id } = item
            this.$router.push({
                name: 'DoctorProduction',
                query: {
                    production_id
                }
            })
        }
    }
}
</script>
<style>
</style>
<style scoped>
.teach-page-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #f4f4f4;
    position: relative;
}

.teach-page-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #2772ff;
}

.teach-page-name-wrap {
    margin-top: 1.34rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
}

.teach-page-name {
    margin-left: 4.93rem;
    font-weight: bold;
    font-size: 0.85rem;
    color: #ffffff;
}

.teach-page-dept {
    margin-bottom: 0.1rem;
    margin-left: 0.64rem;
    font-size: 0.51rem;
    color: #ffffff;
}

.teach-page-info {
    margin-top: 0.4rem;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #ffffff;
    border-radius: 0.43rem 0rem 0rem 0rem;
}

.teach-page-icon-wrap {
    display: flex;
    flex-direction: row;
    width: 100%;
    position: relative;
}

.teach-page-icon {
    position: absolute;
    top: -1.7rem;
    left: 0.85rem;
    width: 3.4rem;
    height: 3.4rem;
    box-shadow: 0rem 0.09rem 0.17rem 0rem rgba(206, 206, 206, 0.4);
    border: solid 0.04rem #ffffff;
    border-radius: 1.7rem;
}

.teach-page-hospital {
    margin-top: 0.43rem;
    margin-bottom: 1.45rem;
    margin-left: 4.93rem;
    font-size: 0.51rem;
    color: #222222;
}

.teach-page-desc-wrap {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
}

.teach-page-desc-tag {
    color: #222;
}

.teach-page-desc {
    flex: 1;
    /* height: 1.58rem; */
    overflow: hidden;
    font-size: 0.51rem;
    color: #888888;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.teach-page-desc-more {
    margin-right: 0.64rem;
    font-weight: bold;
    font-size: 0.51rem;
    color: #222222;
    cursor: pointer;
}

.teach-page-count {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding: 0 0.5rem;
}

.count-item-number {
    font-weight: bold;
    font-size: 0.77rem;
    color: #222222;
}

.count-item-text {
    margin-left: 0.2rem;
    font-size: 0.47rem;
    color: #222222;
}

.teach-page-tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 0.5rem;
}

.word-wrap {
    margin-right: 0.3rem;
    margin-top: 0.5rem;
    height: 1.09rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0rem 0.36rem;
    background-color: #ffffff;
    border-radius: 0.17rem;
    cursor: pointer;
}

.word-text {
    font-size: 0.51rem;
    color: #222222;
}

.word-active {
    background-color: #dfe6ff;
    box-shadow: 0rem 0.13rem 0.26rem 0rem rgba(18, 68, 241, 0.2);
    border-radius: 0.17rem;
}

.word-active .word-text {
    color: #1244f1;
}

.teach-list-wrap {
    margin-top: 0.4rem;
    flex: 1;
    padding: 0 3.33%;
    overflow-y: auto;
    width: 100%;
}

.teach-list-item-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.teach-page-share-poster {
    width: 1.9rem;
    position: absolute;
    right: 0.45rem;
    bottom: 5rem;
    cursor: pointer;
}
.teach-page-msg {
    width: 1.9rem;
    position: absolute;
    right: 0.45rem;
    bottom: 7.5rem;
    cursor: pointer;
}
</style>